/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */

type StaticImages = {
    readonly [fileName: string]: {
        uri?: string;
    };
}

const imageStaticSourcesByFileName: StaticImages = {
    'pZX3avgU4iWLq2tPe1rt7w.png': { uri: '/images/pZX3avgU4iWLq2tPe1rt7w.png' },
't15GkkWsoZvYmgpRxhofgK.png': { uri: '/images/t15GkkWsoZvYmgpRxhofgK.png' }
}

export default imageStaticSourcesByFileName
